import { useEffect, useRef } from "react";
import { RequiredIndicator } from "../Shared/RequiredIndicator";

export type ValidatedStringFormInputProps = {
    Name: string,
    BaseValue: string,
    Invalid: boolean,
    MaxSize: number,
    ColWidth: number,
    submitting: boolean,
    setValueallback: (val: string) => void,
}

export function ValidatedStringFormInput(props: ValidatedStringFormInputProps) {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (props.submitting) {

            if (props.Invalid) {
                inputRef?.current?.classList.remove("is-valid");
                inputRef?.current?.classList.add("is-invalid");
            }
            else if ((props.BaseValue?.length ?? 0) == 0) {
                inputRef?.current?.classList.remove("is-valid");
                inputRef?.current?.classList.remove("is-invalid");
            }
            else {
                inputRef?.current?.classList.add("is-valid");
                inputRef?.current?.classList.remove("is-invalid");
            }
        }
    }, [props.submitting]);

    return (
        <div className={`col-lg-${props.ColWidth}`} key={`InputControl_${props.Name}`}>
            <label htmlFor={`control_${props.Name}`} className="form-label-alt"><RequiredIndicator isOk={(props.BaseValue?.length ?? 0) > 0} /> {props.Name}</label>
            <input disabled={props.submitting} ref={inputRef} id={`control_${props.Name}`} aria-label={props.Name} className="form-control"
                value={props.BaseValue ?? ''}
                type="text"
                maxLength={props.MaxSize}
                onChange={t => {
                    props.setValueallback(t.currentTarget.value);
                    inputRef?.current?.classList.remove("is-valid");
                    inputRef?.current?.classList.remove("is-invalid");
                }} />
            <div className="invalid-feedback">
                {props.Name} required
            </div>
        </div>);
}